import Performance from '../../../components/People/Performance/Performance'
import React from 'react'

function PerformanceCont(props) {
  const list = []
  return (
    <Performance
      {...{
        list,
      }}
    />
  )
}

export default PerformanceCont
